module.exports = __webpack_public_path__ + "img/invite.01d73dd5.png";